import {request} from '../http';
import domain from '../domain';

var pointService = function(){
	if(domain.env === 'online'){
		this.domain = "//points.51tiangou.com";
	}else{
		this.domain = "//points." + domain.env + ".66buy.com.cn";
	}
};

pointService.prototype._serviceAjaxCom = function(url,params){
	params.url = this.domain + url;
	return request(params);
};

/**
 * 狗粮签到
 * @param params
 */
pointService.prototype.sign = function(params) {
	params.type = 'POST';
    this._serviceAjaxCom("/publics/member/sign", params);
};

//签到分享得狗粮
pointService.prototype.shareSign = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/member/share", params);
};

export default new pointService();